import { MonitorType } from '$shared/constants/MonitorType';
import type { IMonitor } from '$shared/interfaces/api/IMonitor';
import { schemaData } from '$shared/lib/data/SchemaData';
import BaseModel from '../BaseModel';
import DateString from '../DateString';

export class Monitor extends BaseModel<IMonitor> {
  public get id(): string {
    return this.response?.id;
  }

  public get type(): MonitorType | undefined {
    return this.response?.type;
  }

  public get monitoringInterval(): string {
    return this.response?.monitoringInterval || '';
  }

  public get nextMonitoringDate(): DateString | null {
    return DateString.create(this.response?.nextMonitoringDate);
  }

  public get lastMonitoringDate(): DateString | null {
    return DateString.create(this.response?.lastMonitoringDate);
  }

  public get providerId(): string | undefined {
    return this.response?.providerId;
  }

  public get facilityId(): string | undefined {
    return this.response?.facilityId;
  }

  public get isContinuousInterval(): boolean {
    return this.monitoringInterval === schemaData.MonitoringInterval.Continuous;
  }

  public get isDataset(): boolean {
    return this.type === MonitorType.Dataset;
  }

  public toMeta(): ObjectType<any> {
    return {
      enableMonitoring: true,
      monitoringInterval: this.monitoringInterval
    };
  }
}
